var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('table',[_vm._m(0),_c('tbody',_vm._l((_vm.venta),function(producto){return _c('EntregaListaItem',{key:producto.servicio_id,attrs:{"producto":producto}})}),1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('th',[_vm._v("Producto")]),_c('th',[_vm._v("Cantidad")])])
}]

export { render, staticRenderFns }